var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Link _flexInline _mb1 _ls-05 _c-grey-700",attrs:{"href":("#" + _vm.anchorId)}},[_c('div',{staticClass:"_mr075",attrs:{"id":_vm.anchorId}},[_vm._v(_vm._s(_vm.heading))])])}
var staticRenderFns = []

export { render, staticRenderFns }